// Landing page content (DE/EN), Nanouk images and API error normalizer.
// Extracted from pages/Auth.jsx (refactoring v3.67).
import { Sun, Plane, Apple, Footprints } from 'lucide-react';

// Nanouk Images
export const NANOUK = {
    happy: 'https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200&h=200&fit=crop',
    travel: 'https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200&h=200&fit=crop',
    sleeping: 'https://images.unsplash.com/photo-1593275497414-473e94a9152a?w=200https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200&h=200&fit=crop',
    smart: 'https://images.unsplash.com/photo-1563889958768-0fa816b019c7?w=200https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200&h=200&fit=crop',
    trailblazer: 'https://images.unsplash.com/photo-1563889958768-0fa816b019c7?w=200https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200&h=200&fit=crop',
};

export const content = {
    de: {
        // Hero Section - Nanouk Greeting
        heroGreeting: "Hi, ich bin Nanouk!",
        heroSubtitle: "Nanouk verknüpft Schlaf, Ernährung, Fitness & Laborwerte: Nanouk versteht dich — und begleitet dich jeden Morgen sanft in die richtige Richtung.",
        heroQuestion: "Sollen wir heute zusammen starten?",
        heroCta: "Werde mein Buddy",
        twoMinBadge: "Nur 2 Minuten am Tag – Nanouk kümmert sich um den Rest",
        meetNanouk: "Mehr über mich",

        // Target audience chips
        audienceLabel: "Gemacht für:",
        audienceChips: [
            { emoji: '📊', label: 'Self-Tracker' },
            { emoji: '🌱', label: 'Fitness-Einsteiger' },
            { emoji: '🐾', label: 'Alle, die 5 Apps in 1 wollen' },
        ],

        // What Nanouk concretely does (P1)
        coachingTitle: "Was Nanouk konkret für dich tut",
        coachingSubtitle: "Drei spürbare Dinge — jeden einzelnen Tag.",
        coachingItems: [
            {
                time: '🌅 07:30',
                title: 'Daily Briefing Push',
                description: 'Eine konkrete Aktion für deinen Tag — basierend auf Schlaf, Wetter, deinem Wochentag und dem, was du gestern getan hast.',
            },
            {
                time: '🩸 Lab-Befund hochladen',
                title: 'Automatische Quest + 120 XP',
                description: 'Foto vom Befund — Nanouk extrahiert 36 Marker, erkennt Defizite und generiert eine konkrete Quest (z. B. „Sonnen-Quest" bei Vit-D-Mangel).',
            },
            {
                time: '💚 Wenn dein Streak bricht',
                title: 'Sanfte Comeback-Quest',
                description: 'Kein Druck. Nach 2 Tagen Pause bekommst du eine Mini-Quest („Logge an 3 von 7 Tagen irgendetwas") und +100 XP, sobald du wieder da bist.',
            },
        ],
        
        // Day with Nanouk Timeline
        dayTitle: "Ein Tag mit Nanouk",
        daySubtitle: "So begleite ich dich durch deinen Alltag",
        timeline: [
            {
                time: "08:00",
                icon: Sun,
                nanoukImg: 'sleeping',
                title: "Guten Morgen, Buddy!",
                description: "Ich sehe, du hast nur 5 Stunden geschlafen. Lass uns heute sanft starten – wie wäre es mit Yoga statt HIIT?",
                color: "from-orange-400 to-amber-500"
            },
            {
                time: "12:00",
                icon: Apple,
                nanoukImg: 'smart',
                title: "Mittagspause!",
                description: "Du hast heute erst 800 kcal gegessen. Ich habe ein proteinreiches Restaurant in deiner Nähe gefunden!",
                color: "from-green-400 to-emerald-500"
            },
            {
                time: "15:00",
                icon: Plane,
                nanoukImg: 'travel',
                title: "Willkommen in Rom!",
                description: "Neues Revier, Buddy! Ich habe deinen Jetlag-Plan aktiviert. Bleib bis 21 Uhr wach, dann schlafen wir beide wie Welpen.",
                color: "from-cyan-400 to-blue-500"
            },
            {
                time: "19:00",
                icon: Footprints,
                nanoukImg: 'trailblazer',
                title: "Fast geschafft!",
                description: "Noch 1.200 Schritte bis zum Tagesziel! *wedelt aufgeregt mit dem Schwanz* Komm, eine Runde um den Block!",
                color: "from-violet-400 to-purple-500"
            }
        ],
        
        // Quality Promise
        trustTitle: "Geprüfte Expertise & sichere Daten",
        trustSubtitle: "Nanouk hat das Herz eines Freundes, aber das Wissen von Experten.",
        trustBadge: "Med-Gemini verifiziert",
        trustPoints: [
            "Sportmedizinische Leitlinien als Grundlage",
            "Safety-First: Nanouk erkennt seine Grenzen",
            "Keine KI-Halluzinationen – nur fundierte Empfehlungen"
        ],
        trustPrivacyTitle: "Deine Daten bleiben deine Daten",
        trustPrivacyPoints: [
            { emoji: '🇪🇺', label: 'Hosting & Speicherung in der EU' },
            { emoji: '🔒', label: 'Verschlüsselt — und jederzeit löschbar' },
            { emoji: '🚫', label: 'Kein Tracking, kein Werbeverkauf' },
        ],
        trustReadMore: "Alle Details unter Datenschutz",
        
        // Auth
        login: "Anmelden",
        register: "Registrieren",
        email: "E-Mail",
        password: "Passwort",
        name: "Dein Name",
        confirmPassword: "Passwort bestätigen",
        loading: "Lädt...",
        scrollDown: "Mehr erfahren",
        privacyNotice: "Mit der Anmeldung akzeptierst du unsere Datenschutzbestimmungen.",
        alreadyBuddies: "Schon dabei?",
        newBuddy: "Neu hier?",
        tabLogin: "Anmelden",
        tabRegister: "Registrieren",
        tabHint: "Wähle, was auf dich zutrifft:",
        quizCta: "Buddy-Check starten"
    },
    en: {
        // Hero Section
        heroGreeting: "Hi, I'm Nanouk!",
        heroSubtitle: "Nanouk connects sleep, nutrition, fitness & lab values: Nanouk understands you — and gently guides you in the right direction every morning.",
        heroQuestion: "Ready to start our journey together?",
        heroCta: "Become my Buddy",
        twoMinBadge: "Just 2 minutes a day – Nanouk takes care of the rest",
        meetNanouk: "More about me",
        quizCta: "Start Buddy-Check",

        // Target audience chips
        audienceLabel: "Built for:",
        audienceChips: [
            { emoji: '📊', label: 'Self-trackers' },
            { emoji: '🌱', label: 'Fitness beginners' },
            { emoji: '🐾', label: 'Anyone tired of 5 apps' },
        ],

        // What Nanouk concretely does
        coachingTitle: "What Nanouk does for you, concretely",
        coachingSubtitle: "Three tangible things — every single day.",
        coachingItems: [
            {
                time: '🌅 07:30',
                title: 'Daily briefing push',
                description: 'One concrete action for your day — based on sleep, weather, weekday and what you did yesterday.',
            },
            {
                time: '🩸 Upload lab report',
                title: 'Automatic quest + 120 XP',
                description: 'Snap a photo — Nanouk extracts 36 markers, spots deficits, and generates a concrete quest (e.g. a "Sun Quest" for low vitamin D).',
            },
            {
                time: '💚 When your streak breaks',
                title: 'Gentle comeback quest',
                description: 'No pressure. After 2 days off, you get a mini-quest ("Log anything on 3 of 7 days") and +100 XP once you\'re back.',
            },
        ],
        
        // Day with Nanouk Timeline
        dayTitle: "A Day with Nanouk",
        daySubtitle: "How I'll guide you through your day",
        timeline: [
            {
                time: "08:00",
                icon: Sun,
                nanoukImg: 'sleeping',
                title: "Good morning, Buddy!",
                description: "I see you only got 5 hours of sleep. Let's start gentle today – how about yoga instead of HIIT?",
                color: "from-orange-400 to-amber-500"
            },
            {
                time: "12:00",
                icon: Apple,
                nanoukImg: 'smart',
                title: "Lunch time!",
                description: "You've only eaten 800 kcal today. I found a protein-rich restaurant nearby!",
                color: "from-green-400 to-emerald-500"
            },
            {
                time: "15:00",
                icon: Plane,
                nanoukImg: 'travel',
                title: "Welcome to Rome!",
                description: "New territory, Buddy! I've activated your jetlag plan. Stay up until 9 PM, then we'll sleep like puppies.",
                color: "from-cyan-400 to-blue-500"
            },
            {
                time: "19:00",
                icon: Footprints,
                nanoukImg: 'trailblazer',
                title: "Almost there!",
                description: "Just 1,200 steps to your daily goal! *wags tail excitedly* Come on, one quick walk around the block!",
                color: "from-violet-400 to-purple-500"
            }
        ],
        
        // Quality Promise
        trustTitle: "Verified expertise & safe data",
        trustSubtitle: "Nanouk has the heart of a friend, but the knowledge of experts.",
        trustBadge: "Med-Gemini verified",
        trustPoints: [
            "Based on sports medicine guidelines",
            "Safety-First: Nanouk knows his limits",
            "No AI hallucinations – only well-founded recommendations"
        ],
        trustPrivacyTitle: "Your data stays yours",
        trustPrivacyPoints: [
            { emoji: '🇪🇺', label: 'Hosted & stored in the EU' },
            { emoji: '🔒', label: 'Encrypted — deletable any time' },
            { emoji: '🚫', label: 'No tracking, no ad sales' },
        ],
        trustReadMore: "All details on Privacy",
        
        // Auth
        login: "Login",
        register: "Register",
        email: "Email",
        password: "Password",
        name: "Your Name",
        confirmPassword: "Confirm Password",
        loading: "Loading...",
        scrollDown: "Learn more",
        privacyNotice: "By signing up, you accept our privacy policy.",
        alreadyBuddies: "Already a Buddy?",
        newBuddy: "New here?",
        tabLogin: "Log In",
        tabRegister: "Sign Up",
        tabHint: "Pick what applies to you:"
    }
};

// Normalize FastAPI/pydantic error details (arrays of objects crash React when rendered)
export const apiErrorMessage = (error, fallback) => {
    const d = error.response?.data?.detail;
    if (Array.isArray(d)) return d.map((x) => x?.msg || '').filter(Boolean).join(', ') || fallback;
    return typeof d === 'string' ? d : fallback;
};
